<template>
  <div class="home-suitability" data-testid="home-suitability">
    <div class="home-suitability__wrapper">
      <div class="home-suitability__container">
        <Heading
          class="home-suitability__title"
          data-testid="suitability-title"
          :level="2"
        >
          Para investir, é muito importante sabermos seu perfil de investidor
        </Heading>
        <BaseText
          class="home-suitability__message"
          :color="NebraskaColors.elementAlpha"
          size="p4"
          data-testid="suitability-message"
        >
          Preparamos perguntas para descobrir seu perfil e ele funcionará como
          um guia para você fazer escolhas mais conscientes e receber melhores
          sugestões.
        </BaseText>
        <ButtonPrimary
          class="home-suitability__button"
          label="Descobrir o perfil"
          :href="buttonHref"
          applied-on="blur"
          size="md"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ButtonPrimary, Heading } from '@warrenbrasil/nebraska-web';
import { computed } from 'vue';

const buttonHref = computed(() => {
  const { domain, platform } = getDomainAndPlatform();

  return `/onboarding/${domain}/${platform}/suitability`;
});
</script>
<style lang="less" scoped>
.home-suitability {
  .container-width(0, @size-spacing-x1200);
  width: 100%;

  .p3 {
    font-weight: 600;
  }

  &__wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &__container {
    display: flex;
    flex-flow: column;
    gap: @size-spacing-x400;
    color: @text-over-image;
    max-width: 492px;
  }

  &__button {
    margin-top: @size-spacing-x800;
    max-width: 175px;

    :deep(.button--container) {
      font-weight: 400;
    }
  }

  &__title {
    color: @text-over-image;
  }

  &__qrcode {
    display: flex;
    gap: @size-spacing-x500;
    height: fit-content;
    padding: @size-spacing-x600;
    background: rgba(250, 248, 248, 0.15);
    backdrop-filter: blur(9px) saturate(1.5) brightness(1.05);
    -webkit-backdrop-filter: blur(9px) saturate(1.5) brightness(1.05);
    border-radius: @size-radius-x400;

    &--wrapper {
      display: flex;
      gap: @size-spacing-x400;
      flex-direction: column;
    }

    &--steps {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    &--step {
      display: flex;
      align-items: flex-start;
      gap: @size-spacing-x350;
      max-width: 204px;
    }

    &--canvas {
      padding: @size-spacing-x300;
      background: @element-over-image;
      height: 142px;
      display: block;
    }
  }

  @media (max-height: 650px) {
    margin-top: @size-spacing-x600;
  }

  @media (max-width: 1024px) {
    &__wrapper {
      flex-direction: column;
      gap: @size-spacing-x600;
    }

    &__qrcode {
      width: fit-content;

      &--canvas {
        display: none;
      }
    }
  }
}
</style>
